import { Alert, AlertTitle, Box, Divider, Stack } from "@mui/material";
import MenuGroup from "./menu/MenuGroup";
import MenuItem from "./menu/MenuItem";
import GroupsIcon from "@mui/icons-material/Groups";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AssignmentIcon from "@mui/icons-material/Assignment";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import HomeIcon from "@mui/icons-material/Home";

function ProjectSidebar() {
    return (
        <Stack widht="100%" heigth="100%">
            <Box>
                <MenuItem to="/workspace" text="Personal's Workspace" icon={<HomeIcon />} />
            </Box>

            <Divider />

            <MenuGroup text="Project's Menu">
                <MenuItem to="/workspace/groups" text="Groups/Teams" icon={<GroupsIcon />} />
                <MenuItem to="/strategic-plans" text="Strategic Plans" icon={<AccountTreeIcon />} />
                <MenuItem to="/projects" text="Projects" icon={<AssignmentIcon />} />
                <MenuItem to="/kpis" text="KPIs" icon={<QueryStatsIcon />} />
                <MenuItem to="/data-collections" text="Data Collections" icon={<FolderZipIcon />} />
            </MenuGroup>
        </Stack>
    );
}

export default ProjectSidebar;
